import {RouteObject} from 'react-router';
import {lazyAdminRoute} from '@common/admin/routes/lazy-admin-route';

export const appSettingsRoutes: RouteObject[] = [
  {path: 'header', lazy: () => lazyAdminRoute('HeaderSettings')},
  {
    path: 'home-banner',
    lazy: () => lazyAdminRoute('HomeBannerSettings'),
  },
  {
    path: 'primary-features',
    lazy: () => lazyAdminRoute('PrimaryFeaturesSettings'),
  },
  {path: 'brands', lazy: () => lazyAdminRoute('BrandsSettings')},
  {path: 'stats', lazy: () => lazyAdminRoute('StatsSettings')},
  {
    path: 'pricing-lifetime',
    lazy: () => lazyAdminRoute('PricingLifetimeSettings'),
  },
  {
    path: 'pricing-features',
    lazy: () => lazyAdminRoute('PricingFeaturesSettings'),
  },
  {
    path: 'pricing-payment-methods',
    lazy: () => lazyAdminRoute('PricingPaymentMethodsSettings'),
  },
  {
    path: 'business-banner',
    lazy: () => lazyAdminRoute('BusinessBannerSettings'),
  },
  {
    path: 'business-pricing',
    lazy: () => lazyAdminRoute('BusinessPricingSettings'),
  },
  {
    path: 'business-logos',
    lazy: () => lazyAdminRoute('BusinessLogosSettings'),
  },
  {
    path: 'business-workflow',
    lazy: () => lazyAdminRoute('BusinessWorkflowSettings'),
  },
  {
    path: 'business-testimonial',
    lazy: () => lazyAdminRoute('BusinessTestimonialSettings'),
  },
  {
    path: 'business-cutting-edge',
    lazy: () => lazyAdminRoute('BusinessCuttingEdgeSettings'),
  },
  {
    path: 'business-advertisement',
    lazy: () => lazyAdminRoute('BusinessAdvertisementSettings'),
  },
  {path: 'drive', lazy: () => lazyAdminRoute('DriveSettings')},
  {
    path: 'upload-notification',
    lazy: () => lazyAdminRoute('UploadNotificationSettings'),
  },
];
